<template>
  <div class="menubar-footer">

    <img class="d-block mx-auto" src="@/assets/menubar/menubar_footer_img.svg" />
    <p class="my-2 text-center">
      A good friend doesn't let their friends waste their day.
      <!-- A good friend don't let friends waste their day. Invite them to Goalpilot. -->
    </p>

    <el-button class="trial-button d-block" @click="onInviteClick">
      Invite to Goalpilot
      <!-- Tell about Goalpilot -->
    </el-button>

  </div>
</template>

<script>
import InvitePromptMixin from '@/components/Mixins/Prompts/InvitePrompt'

export default {
  mixins: [ InvitePromptMixin ],
  data: () => ({
  }),
  computed: {},
  methods: {
    onInviteClick() {
      this.$invite_prompt({
        type: 'Goalpilot'
      })
    },

    onClickUpgradeButton() {
      this.$router.push('/upgrade')
    },
  },
};
</script>
